import { useState } from 'react'

export function useFilter<T>({ data, defaultFilterField }: { data: T[]; defaultFilterField?: keyof T }) {
  const [filterField, setFilterField] = useState<keyof T | undefined>(defaultFilterField)
  const [search, setSearch] = useState('')

  const handleFilterFieldChange = (field: keyof T | undefined) => {
    setFilterField(field)
    setSearch('')
  }

  const handleSearchChange = (search: string) => setSearch(search)

  // Immediate filtering based on current search term
  const filteredData = !search
    ? data
    : data.filter(item => {
        if (filterField && search) {
          const fieldValue = item[filterField]
          if (fieldValue === null || fieldValue === undefined) return false

          const normalizeString = (str: string) =>
            str
              .toLocaleLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')

          const searchNormalized = normalizeString(search)
          const fieldNormalized = normalizeString(fieldValue.toString())

          return fieldNormalized.includes(searchNormalized)
        }
        return true
      })

  return {
    // State
    filterField,
    search,
    filteredData,

    // Actions
    setFilterField,
    setSearch,

    // Handlers
    handleFilterFieldChange,
    handleSearchChange,
  }
}
